import { defineComponent, reactive } from "vue";
import type { FileUploadProps } from "./types";
import { FORM_INPUT_FIELD_PROPS } from "../form/input/types";
import Button from "../button";
import { useAsyncAction } from "@/utils/async/useAsyncAction";
import { useFileDialog } from "@vueuse/core";
import type { FindexFile } from "@/types/file";
import UploadIcon from 'assets/img/svg/icons/upload.svg?url';

const FileUpload = defineComponent<FileUploadProps>({
  setup(props) {
    const fileDialog = useFileDialog({
      accept: props.accept || '*'
    });

    const state = reactive<{ file: File | undefined }>({
      file: undefined
    })

    fileDialog.onChange((files: FileList | null) => {
      if (!files || files.length <= 0) return;
      const file = files.item(0);
      if (!file) return;
      state.file = file;
      const fieldRef = props.fieldRef;
      const reportChange = props.reportChange;
      if (fieldRef && reportChange) {
        const findexFile: FindexFile = {
          item: file
        };
        reportChange(fieldRef, findexFile);
      }
    });

    const clickAction = useAsyncAction(async () => {
      fileDialog.reset();
      fileDialog.open();
    });

    return () => {
      return  <Button onlyIcon icon={{
          src: UploadIcon,
          stroke: 'currentColor',
          size: 14
        }} onClick={clickAction.call} isLoading={clickAction.loading.value}/>
    }
  }
});

FileUpload.props = [...FORM_INPUT_FIELD_PROPS, 'accept'];

export default FileUpload;
